var MAX_PRECEDENCE = 8;
/**
 * If candidate is binary token on presedence, then return corresponding binary operator
 */
function isTokenBinaryOperator(presedence, candidate) {
    switch (presedence) {
        // TODO: Why or/and have different prio?
        case 8:
            return candidate === "or keyword" ? "or keyword" : undefined;
        case 7:
            return candidate === "and keyword" ? "and keyword" : undefined;
        case 6:
            return candidate === "greater than eq token"
                ? "greater than eq token"
                : candidate === "less than eq token"
                    ? "less than eq token"
                    : candidate === "greater than token"
                        ? "greater than token"
                        : candidate === "less than token"
                            ? "less than token"
                            : candidate === "equals token"
                                ? "equals token"
                                : candidate === "not equals token"
                                    ? "not equals token"
                                    : candidate === "in keyword"
                                        ? "in keyword"
                                        : undefined;
        case 5:
            return undefined /* here was "in keyword */;
        case 4:
            return candidate === "to keyword" ? "to keyword" : undefined;
        case 3:
            return candidate === "plus token"
                ? "plus token"
                : candidate === "minus token"
                    ? "minus token"
                    : undefined;
        case 2:
            return candidate === "asterisk token"
                ? "asterisk token"
                : candidate === "slash token"
                    ? "slash token"
                    : undefined;
        case 1:
            return candidate === "div keyword"
                ? "div keyword"
                : candidate === "mod keyword"
                    ? "mod keyword"
                    : undefined;
        default:
            throw new Error("Unknown presedence " + presedence);
    }
}
function createReaderClassSkipWhitespaces(reader) {
    var currentToken;
    var readNext = function () {
        currentToken = reader();
        while (currentToken.kind === "white space token") {
            currentToken = reader();
        }
    };
    readNext();
    return {
        current: function () {
            return currentToken;
        },
        readNext: readNext,
    };
}
export function parseExpression(readerFunc) {
    var reader = createReaderClassSkipWhitespaces(readerFunc);
    /**
     * Expects current = open paren token
     * Returns when position is after "close paren token"
     */
    function readParenExpression() {
        reader.readNext();
        if (reader.current().kind === "identifier") {
            var paramRegexpMatch = reader.current().text.match(/^p(\d+)$/);
            if (!paramRegexpMatch) {
                throw new Error("Unknown parameter '" + reader.current().text + "' at " + reader.current().start);
            }
            var pNumber = paramRegexpMatch[1];
            var pId = parseInt(pNumber) - 1;
            var exp = {
                type: "parameter",
                parameterId: pId,
            };
            reader.readNext();
            if (reader.current().kind !== "close paren token") {
                throw new Error("Expected ], but got '" + reader.current().text + "' at " + reader.current().start);
            }
            reader.readNext();
            return exp;
        }
        else {
            var ranges = [];
            while (true) {
                if (reader.current().kind === "semicolon token") {
                    reader.readNext();
                    continue;
                }
                if (reader.current().kind === "close paren token") {
                    reader.readNext();
                    break;
                }
                var from = readExpr();
                if (reader.current().kind === "dotdot token") {
                    reader.readNext();
                    var to = readExpr();
                    ranges.push({
                        from: from,
                        to: to,
                    });
                }
                else if (reader.current().kind === "close paren token" ||
                    reader.current().kind === "semicolon token") {
                    ranges.push({
                        from: from,
                    });
                }
                else {
                    throw new Error("Unexpected token inside paren '" + reader.current().text + "' pos=" + reader.current().start + " ");
                }
            }
            var expr_1 = {
                type: "range",
                ranges: ranges,
            };
            return expr_1;
        }
    }
    function readPrim() {
        var primStartToken = reader.current();
        if (primStartToken.kind === "numeric literal") {
            var expr_2 = {
                type: "number",
                value: parseFloat(primStartToken.text.replace(",", ".").replace(/ /g, "")),
            };
            reader.readNext();
            return expr_2;
        }
        else if (primStartToken.kind === "open paren token") {
            var expr_3 = readParenExpression();
            return expr_3;
        }
        else if (primStartToken.kind === "open brace token") {
            reader.readNext();
            var expr_4 = readExpr();
            if (reader.current().kind !== "close brace token") {
                throw new Error("Expected close brace token but got " + reader.current().text + " at " + reader.current().start);
            }
            reader.readNext();
            return expr_4;
        }
        else if (primStartToken.kind === "minus token") {
            reader.readNext();
            var innerExpr = readPrim();
            var expr_5 = {
                type: "unary",
                expression: innerExpr,
                operator: "minus token",
            };
            return expr_5;
        }
        else {
            if (reader.current().kind === "end token") {
                throw new Error("Expected value at " + reader.current().start);
            }
            else {
                throw new Error("Expecting primary value at " + reader.current().start + " but got '" + reader.current().text + "' kind=" + reader.current().kind);
            }
        }
    }
    function readExpr(currentPriority) {
        if (currentPriority === void 0) { currentPriority = MAX_PRECEDENCE; }
        if (currentPriority === 0) {
            var prim = readPrim();
            return prim;
        }
        var left = readExpr(currentPriority - 1);
        while (true) {
            var possibleBinaryTokenKind = reader.current().kind;
            if (possibleBinaryTokenKind === "end token") {
                return left;
            }
            var possibleBinaryToken = isTokenBinaryOperator(currentPriority, possibleBinaryTokenKind);
            if (!possibleBinaryToken) {
                return left;
            }
            reader.readNext();
            var right = readExpr(currentPriority - 1);
            var newLeft = {
                type: "binary",
                operator: possibleBinaryToken,
                left: left,
                right: right,
            };
            left = newLeft;
        }
    }
    var expr = readExpr();
    if (reader.current().kind !== "end token") {
        throw new Error("Unexpected data at " + reader.current().start + ": '" + reader.current().text + "' kind=" + reader.current().kind);
    }
    return expr;
}
// const scanner = Scanner("1 + 2*5*(5-4)");
//const scanner = Scanner("1 + 2*5");
//const scanner = Scanner("2+(2 *2 +3   )+4");
/*
const scanner = Scanner("3 + [ -10 ..  -12; -3]");

const exp = parseExpressionReader(scanner);
console.info(exp);
*/
//# sourceMappingURL=data:application/json;base64,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